// extracted by mini-css-extract-plugin
export var active = "_cp-7";
export var blink = "_cp-8";
export var dropDownSelector = "_cp-4";
export var dropDownWrapper = "_cp-3";
export var fakeCursor = "_cp-6";
export var fontSizeButton = "_cp-9";
export var formQuillEditor = "_cp-0";
export var pressed = "_cp-a";
export var qlBlank = "_cp-1";
export var textFormattingToolbar = "_cp-2";
export var textToolbarOption = "_cp-5";